//
// DataVisualElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElementController";
import "../results/ResultController";
import "../../util/tooltip/TooltipDrillController";
import "../../util/displayRules/DisplayRuleInfo";
import "../results/FilterDescription";
import "../../util/tooltip/TooltipEvent";
import "../../util/tooltip/TooltipSortController";
import "../dataDefinition/RolesAssignmentController";
import "../dataDefinition/DataDefinitionFilterController";
import "../dataDefinition/RanksController";
import "../dataDefinition/GroupingController";
import "@sas-dvr/ltjs-commons/pickResults/PickResult";
import "../../models/dataDefinition/DataItem";
import "@sas-dvr/ltjs-commons/models/datagrid/CellVisualType";
import "../../models/common/NestedElementPosition";
import "../../models/visualElements/RowNumbers";
import "../dataDefinition/DataItemInfo";
import "@sas-dvr/ltjs-commons/util/BaseVoucher";
import "@sas-dvr/ltjs-commons/selection/Selection";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataSet";

var DataVisualElementController = createModule("BIRD_DataVisualElementController", [40040,40351,40490,40150], EventDispatcher, [
    {
        REQUIRED_ROLES_NOT_ASSIGNED: 50001,
    },
    ,
    ,
    ,
    {
        getSelectedDataItemInfosForExplainText: [[1]],
        canSelectAll: [2],
        freezeColumns: [0,4],
        supportsMultiSelect: [2],
        getOmittedSubTotalCategories: [[1]],
        getTooltipSortControllerWithAllSortItems: [1,[1]],
        getCurrentSelectedPickResults: [[1]],
        setCompactFormatForColumn: [0,2,4],
        editOrCreateCellVisual: [0,4,4,4],
        getResultControllers: [[1]],
        getCellVisualPosition: [4,4],
        getExplainTextForDataItem: [1,1],
        getDataItemInfo: [1,1],
        triggerInteractions: [0],
        noneSelected: [2],
        getDisplayRuleInfos: [[1]],
        deselectAll: [0],
        isPromptFilter: [2],
        columnIsFrozen: [2,4],
        getCellVisualType: [4,4],
        resetSort: [0],
        getDownstreamInteractedControllers: [[1]],
        getTooltipDrillController: [1,7,7],
        selectAll: [0],
        supportsTotal: [2,4,4],
        setTotalVisible: [0,4,4,2],
        getRanksController: [1],
        getOmittedSubTotalMeasures: [[1]],
        columnIsUsingCompactFormat: [2,4],
        setCompactFormat: [0,2],
        getDataSourceLabels: [[7]],
        getDataDefinitionFilterController: [1],
        allSelected: [2],
        getCellVisualColorForStyleAttribute: [10,4,4],
        getRolesAssignmentController: [1],
        getDataSetsForSelections: [[1]],
        getTooltipEventForPickResults: [1,[1]],
        isSectionFilter: [2],
        isUsingCompactFormat: [2],
        getRowNumbers: [1],
        getSelectedDataItemsForExplainText: [[1]],
        hasSubtotalVariables: [2],
        getAllDrillControllers: [[1]],
        _getFilterDescriptions_bbbbb: [[1],2,2,2,2,2],
        getGroupingController: [1],
        isTotalVisible: [2,4,4],
        _getFilterDescriptions_bbb: [[1],2,2,2],
        getOmittedTotalItems: [[1]],
        isOmittedFromSubtotals: [2,1],
        supportsCellVisuals: [2,4],
        columnSupportsCompactFormat: [2,4],
        isOmittedFromTotals: [2,1],
        getSelectionsForDataSets: [[1]],
        retrieveUniqueValuesForLevel: [0,7,7,4],
        setOmittedTotalItem: [0,1,4,2],
        getCategoryTotalVariables: [[1]],
        supportsFreezingColumns: [2],
        getDrillController: [1,7,7],
        getMeasureTotalVariables: [[1]],
        setRowNumbers: [0,1],
    },
    ,
    ["getFilterDescriptions"],
]);
export default DataVisualElementController;
